import { useEffect } from "react";

export default function RedirectType() {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent;

      if (/iPhone|iPad|iPod/i.test(userAgent)) {
        window.location.href =
          "https://apps.apple.com/au/app/woost-influencer-marketing/id6461419665?source=deeplink";
      } else if (/Android/i.test(userAgent)) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.woost&hl=en&source=deeplink";
      } else {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.woost&hl=en&source=deeplink";
      }
    }
  }, []);

  return (
    <div style={{ textAlign: "center", marginTop: "4rem" }}>
      <h2>Redirecting...</h2>
      <p>
        If you are not redirected,{" "}
        <a href="https://play.google.com/store/apps/details?id=com.woost&hl=en&source=deeplink">
          click here
        </a>
        .
      </p>
    </div>
  );
}
